import EventEmitter from 'tools/eventEmitter'

export const toastController = EventEmitter()

export const TOAST_EVENTS = {
  SHOW: 'SHOW',
  CLOSED: 'CLOSED'
}

export default (...args) => toastController.emit(TOAST_EVENTS.SHOW, ...args)
